import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { formatAiCreditsAmount } from '~src/utils/aiCreditsHistory';

export const LoaderState = ({ label }) => {
  return (
    <div className="ai-credits-history__state">
      <Spinner animation="border" variant="info" />
      <span>{label}</span>
    </div>
  );
};

LoaderState.propTypes = {
  label: PropTypes.string,
};

export const InsightCard = ({ label, value, hint, tone = 'neutral' }) => {
  return (
    <div
      className={`ai-credits-history__kpi-card ai-credits-history__kpi-card--${tone}`}
    >
      <span className="ai-credits-history__kpi-label">{label}</span>
      <strong className="ai-credits-history__kpi-value">{value}</strong>
      {hint ? (
        <small className="ai-credits-history__kpi-hint">{hint}</small>
      ) : null}
    </div>
  );
};

InsightCard.propTypes = {
  hint: PropTypes.string,
  label: PropTypes.string,
  tone: PropTypes.string,
  value: PropTypes.string,
};

const getMaxValue = (items, key) => {
  return items.reduce((maxValue, item) => {
    return Math.max(maxValue, item[key]);
  }, 0);
};

export const ChartRows = ({
  items,
  emptyLabel,
  tone,
  multiline = false,
  valueKey = 'total',
  getValueLabel = (item) => formatAiCreditsAmount(item[valueKey]),
  getSecondaryLabel,
}) => {
  if (items.length === 0) {
    return <p className="ai-credits-history__empty-chart">{emptyLabel}</p>;
  }

  const maxValue = getMaxValue(items, valueKey);

  return (
    <div className="ai-credits-history__chart-rows">
      {items.map((item) => {
        const secondaryLabel = getSecondaryLabel ? getSecondaryLabel(item) : '';

        return (
          <div
            key={item.key || item.id || item.label}
            className="ai-credits-history__chart-row"
          >
            <span
              className={`ai-credits-history__chart-label${
                multiline ? ' ai-credits-history__chart-label--multiline' : ''
              }`}
            >
              {item.label}
            </span>
            <div className="ai-credits-history__bar-track">
              <span
                className={`ai-credits-history__bar-fill ai-credits-history__bar-fill--${tone}`}
                style={{
                  width: `${
                    maxValue > 0 ? (item[valueKey] / maxValue) * 100 : 0
                  }%`,
                }}
              ></span>
            </div>
            <div className="ai-credits-history__chart-metrics">
              <strong className="ai-credits-history__chart-value">
                {getValueLabel(item)}
              </strong>
              {secondaryLabel ? (
                <small className="ai-credits-history__chart-secondary">
                  {secondaryLabel}
                </small>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

ChartRows.propTypes = {
  emptyLabel: PropTypes.string,
  getSecondaryLabel: PropTypes.func,
  getValueLabel: PropTypes.func,
  items: PropTypes.array.isRequired,
  multiline: PropTypes.bool,
  tone: PropTypes.string,
  valueKey: PropTypes.string,
};
